import {Space, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import TeamFotoAtributions from './TeamFotoAtributions';

const {Title} = Typography;

const TeamDisplay = () => {
  return (
    <Layout className='PurpBack' style={{background: 'white'}}>
      <Layout style={{margin: '50px', background: 'inherit'}}>
        <Title level={1} style={{color: appColors['ColorA'], textAlign: 'center'}}>Advisors</Title>
        <Space align="start" style={{background: 'inherit', maxWidth: '100%', justifyContent: 'space-evenly'}}>
          <TeamFotoAtributions foto='https://static.igem.wiki/teams/4464/wiki/team/alvaro.png' titulo='PhD. Álvaro de Obeso' base='Molecular Microbiology'/>
          <TeamFotoAtributions foto='https://static.igem.wiki/teams/4464/wiki/team/mariog.png' titulo='PhD. Mario González' base='Developmental Biology and Cancer'/>
          <TeamFotoAtributions foto='https://static.igem.wiki/teams/4464/wiki/team/carlos.png' titulo='PhD. Carlos Díaz' base='Clinical Research, Biochemistry and Bioprocesses'/>
          <TeamFotoAtributions foto='https://static.igem.wiki/teams/4464/wiki/team/advisormichael.jpeg' titulo='PhD. Michael Magaraci' base='iGEM Mentor Research scientist focused on protein evolution'/>
        </Space>
      </Layout>
    </Layout>
  );
};

export default TeamDisplay;
